import getStore from 'services/getStore';

const store = getStore();

const values = {
  headerHeight: 70,
};

const colors = {
  lPink: '#ff0063',
  lBlue0: '#b3cde0',
  lGrey0: '#282a2b',
  lGrey1: '#dee3f3',
  lGrey2: '#ecedf0',
  lGrey3: '#eaeffb',
  lGrey4: '#f5f8fa',
  lTeal0: '#3c95a4',
  lTeal1: '#32d0d0',
};

const focusBorder = '1px solid #2684FF !important';
const focusBoxShadow = '0 0 0 1px #2684FF !important';

function getButtonFocus(color, shadowBefore = null, useTransition = true) {
  const { highContrast = false } = store.getState().theme;

  return !window.dev()
    ? `
    box-shadow: ${
      shadowBefore ? `${shadowBefore}, ` : ''
    }0 0 0 2px #fff, 0 0 0 ${highContrast ? 5 : 3}px ${color} !important;`
    : '';
}

export { values, colors, focusBorder, focusBoxShadow, getButtonFocus };
